import { ProfileStore } from "@apphq/user-profile";
import { Ability, AbilityBuilder } from "@casl/ability";
import { inject, injectable } from "inversify";
import { RoleChecker } from "@/api/services";

/**
 * Cf. https://docs.mongodb.com/manual/reference/operator/query/
 */

@injectable()
export default class AbilityRulesFactory {
  constructor(
    @inject(RoleChecker) private roleChecker: RoleChecker,
    @inject(ProfileStore) private profileStore: ProfileStore
  ) {}

  /**
   * Automatically update the abilities when the user state changes
   */
  public manageAbility(ability: Ability) {
    ability.update(this.getRules());
    this.roleChecker.$watch(
      roleChecker => roleChecker.isLoggedIn,
      () => ability.update(this.getRules())
    );
    this.profileStore.$watch(
      profileStore => profileStore.loginName,
      () => ability.update(this.getRules())
    );
  }

  /**
   * Calculate abilities of the current user
   */
  public getRules() {
    const loginName = this.profileStore.loginName;

    const { rules, can: allow, cannot: forbid } = AbilityBuilder.extract();

    if (this.roleChecker.hasRole("rvkCustomerUser")) {
      allow(["read", "update"], "Task");
    }

    // if (this.roleChecker.hasRole("rvkCustomerAdmin")) {}

    // if (this.roleChecker.hasRole("rvkCustomerSuperUser")) {}

    // if (this.roleChecker.hasRole("rvkRhenusUser")) {}

    if (this.roleChecker.hasRole("rvkRhenusAdmin")) {
      allow("create", "Task");
      allow("read", "Log");
    }

    if (this.roleChecker.hasRole("rvkRhenusSuperUser")) {
      allow("manage", "User");
      allow("read", "CompleteLog");
    }

    return rules;
  }
}
